import { enumLanguage } from "@configs";
import { selectApp, setLanguage } from "@redux";

import { Dropdown } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { EngIcon } from "./icon";

export const LangDropdown = ({
    setComponentsLanguage,
}: {
    setComponentsLanguage?: (lang: string) => void;
}) => {
    const dispatch = useDispatch();
    const { lang } = useSelector(selectApp);
    const { t, i18n } = useTranslation();
    const [visible, setVisible] = useState(false); // ควบคุม dropdown เปิด-ปิด

    const handleChangeLang = (params: enumLanguage) => {
        i18n.changeLanguage(params);

        if (params === enumLanguage.TH) {
            dispatch(setLanguage("THAI"));
            setComponentsLanguage && setComponentsLanguage("th");
        } else {
            dispatch(setLanguage("ENGLISH"));
            setComponentsLanguage && setComponentsLanguage("en");
        }
        setVisible(false); // ปิด dropdown หลังจากเลือกภาษา
    };

    return (
        <StyledLayout>
            <Dropdown
                menu={{
                    items: [
                        {
                            key: "1",
                            label: (
                                <StyledText onClick={(e) => e.preventDefault()}>
                                    <span>
                                        <EngIcon />
                                    </span>
                                    <p style={{ color: "black" }}>{t("page.lang_en")}</p>
                                </StyledText>
                            ),
                            onClick: () => {
                                handleChangeLang(enumLanguage.EN);
                            },
                        },
                        {
                            key: "2",
                            label: (
                                <StyledText onClick={(e) => e.preventDefault()}>
                                    <span>
                                        {/* <ThaiIcon /> */}
                                        <img src="../images/ic-thai-png.png" alt="" />
                                    </span>
                                    <p style={{ color: "black" }}>{t("page.lang_th")}</p>
                                </StyledText>
                            ),
                            onClick: () => handleChangeLang(enumLanguage.TH),
                        },
                    ],
                }}
                trigger={["click"]}
                onOpenChange={(flag) => setVisible(flag)}
                // onOpenChange={(flag) => setVisible(flag)}
                open={visible}
            >
                {lang === "ENGLISH" ? (
                    <StyledText onClick={(e) => e.preventDefault()}>
                        <span>
                            <EngIcon />
                        </span>
                        <p>{t("page.lang_en")}</p>
                    </StyledText>
                ) : (
                    <StyledText onClick={(e) => e.preventDefault()}>
                        <span>
                            {/* <ThaiIcon /> */}
                            <img src="../images/ic-thai-png.png" alt="" />
                        </span>
                        <p>{t("page.lang_th")}</p>
                    </StyledText>
                )}
            </Dropdown>
        </StyledLayout>
    );
};

const StyledUpArrow = styled.div`
    position: absolute;
    top: -15px;
    right: 12px;
`;
const StyledLayout = styled.div``;
const StyledText = styled.div`
    position: relative;
    z-index: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    p {
        margin: 0;
        color: #fff;
        font-weight: 500;
        padding-left: 2px;
    }
    span {
        border-radius: 100%;
        overflow: hidden;
        width: 20px;
        height: 20px;
        margin-right: 5px;
        display: inline-block;
        /* border: 2px solid #fdfdfe; */
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        svg {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
`;
const StyledUl = styled.ul`
    width: auto;
    margin: 0;
    list-style: none;
    padding: 8px;
    background: #ffffff;
    border-radius: 4px;
    position: relative;
    box-shadow: rgb(0 0 0 / 24%) 0px 3px 8px;
`;
const StyledLi = styled.li`
    padding: 4px 2px;
    cursor: pointer;
    display: flex;
    align-items: center;
    span {
        border-radius: 100%;
        overflow: hidden;
        width: 20px;
        height: 20px;
        margin-right: 5px;
        display: inline-block;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        svg {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
`;
